let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("G6tUl")).then(() => parcelRequire('66R31'));